module.exports = __webpack_public_path__ + "img/cz-partners-hospodarske_noviny.b18615b3.png";